import { render, staticRenderFns } from "./UserBillGrowth.vue?vue&type=template&id=2fd60ce0&"
import script from "./UserBillGrowth.vue?vue&type=script&lang=js&"
export * from "./UserBillGrowth.vue?vue&type=script&lang=js&"
import style0 from "./UserBillGrowth.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports